'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useRef, useState } from 'react';

import { recentHistoryBunja } from '@flipster/features/src/recent-history/state';
import { FormattedMessage } from '@flipster/i18n';
import ChevronDownIcon from '@flipster/react/icon/generated/ChevronDownIcon';
import ChevronUpIcon from '@flipster/react/icon/generated/ChevronUpIcon';
import TrashIcon from '@flipster/react/icon/generated/TrashIcon';
import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { MarketEvent } from '@flipster/utils/segment/events/market';

import { RecentSearchHistoryItem } from './recent-search-history-item';

interface Props {
  onClickItem?: () => void;
  className?: string;
}

export const RecentSearchHistory = ({ onClickItem, className }: Props) => {
  const { historiesAtom, clearRecentSearchHistory } = useBunja(recentHistoryBunja);
  const histories = useAtomValue(historiesAtom);
  const [expanded, setExpanded] = useState<boolean>(false);

  const listRef = useRef<HTMLUListElement>(null);

  const handleOnClickTrash = () => {
    clearRecentSearchHistory();
    segment.track(MarketEvent.SearchHistoryBinClick);
  };

  // n줄 고정 로직, 나중에 쓸 일 있을수도 있음
  // const [maxLength, setMaxLength] = useState<number>(histories.length);
  // useIsomorphicLayoutEffect(() => {
  //   const element = listRef.current;
  //   const maxLine = expanded ? 4 : 2;
  //   const lineHeight = 32;
  //   const gap = 8;
  //   if (element != null) {
  //     const { height } = element.getBoundingClientRect();
  //     const expectedHeight = lineHeight * maxLine + gap * (maxLine - 1);
  //     if (height > expectedHeight) {
  //       setMaxLength((prev) => Math.max(0, prev - 1));
  //     } else if (height < expectedHeight) {
  //       setMaxLength((prev) => Math.min(histories.length, prev + 1));
  //     }
  //   }
  // }, [expanded, histories, maxLength]);

  if (histories.length === 0) return null;

  return (
    <div className={className}>
      <div
        className={flex({
          justify: 'space-between',
          marginBottom: '8px',
          px: { base: '0', smallDesktop: '8px' },
          color: 'content.default.level-2',
        })}
      >
        <span className={css({ textStyle: 'Text/M/Regular' })}>
          <FormattedMessage id='Assets.r250401.Recent_history' />
        </span>
        <button
          className={css({ color: 'content.default.level-2', lineHeight: 0 })}
          type='button'
          onClick={handleOnClickTrash}
        >
          <TrashIcon size={20} />
        </button>
      </div>
      <ul ref={listRef} className={flex({ flexWrap: 'wrap', gap: 8 })}>
        {histories.slice(0, expanded ? 10 : 4).map((history, index) => (
          <RecentSearchHistoryItem key={history} symbol={history} index={index} onClickItem={onClickItem} />
        ))}
        {histories.length > 4 && (
          <li key='expand'>
            <button
              className={flex({
                justify: 'center',
                align: 'center',
                background: 'background.default.level-3',
                color: 'content.default.level-2',
                width: 32,
                height: 32,
                rounded: 16,
              })}
              onClick={() => setExpanded((prev) => !prev)}
            >
              {expanded ? <ChevronUpIcon size={16} /> : <ChevronDownIcon size={16} />}
            </button>
          </li>
        )}
      </ul>
    </div>
  );
};
